import {
  BenderSearchTasksResponse,
  TBenderInputs
} from '@/services/Bender/Task/contract/response/BenderSearchTasks.response'
import { BenderApi } from '@services'
import { useEffect, useState } from 'react'

export const useBenderTask = (taskId?: string) => {
  const [IRPFInfo, setIRPFInfo] =
    useState<
      BenderSearchTasksResponse<TBenderInputs['IRPFReview']>['tasks'][0]['input']['IrpfStatement']
    >()
  const [personProfileInfo, setPersonProfileInfo] =
    useState<
      BenderSearchTasksResponse<TBenderInputs['IRPFReview']>['tasks'][0]['input']['PersonInfo']
    >()
  const [executionArn, setExecutionArn] = useState<string>()

  const bootstrap = async () => {
    const { tasks } = await BenderApi.task.search<TBenderInputs['IRPFReview']>({
      filter: { id: taskId },
      fields: ['input'],
      limit: 1
    })
    setIRPFInfo(tasks[0].input.IrpfStatement)
    setPersonProfileInfo(tasks[0].input.PersonInfo)
    setExecutionArn(tasks[0].input.Execution?.ExecutionArn)
  }

  useEffect(() => {
    bootstrap()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { personProfileInfo, executionArn, IRPFInfo }
}
